import { useSalesChannelMode } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useSalesChannelModeWithSister } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import NoAccess from 'src/components/NoPermission';
import { controlledPath } from './controlledPath';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  SalesChannelMode,
  SalesChannelModeWithSister,
} from 'src/types/common/SalesChannel';

const handleOnDisplay = (mode) => {
  return mode === SalesChannelMode.ECOMMERCE;
};

const handleOnDisplay_InfoEcom = (scMode) => {
  return (
    scMode === SalesChannelModeWithSister.I_E ||
    scMode === SalesChannelModeWithSister.E_Only
  );
};

const handleOnDisplayComponent = (mode, Component, Replacement?) => {
  return handleOnDisplay(mode) ? Component : Replacement || <React.Fragment />;
};

const SalesChannelModeAccessControlHOC = (Component, params?) => {
  const WrappedComponent = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => {
      return i18nGet(i18n, str);
    };
    const mode = useSalesChannelMode();
    const scMode = useSalesChannelModeWithSister();
    const matches = useRouteMatch();
    const path = get(matches, 'path');
    const isscMode = params?.isscMode || false;

    return controlledPath.includes(path) ? (
      (isscMode ? handleOnDisplay_InfoEcom(scMode) : handleOnDisplay(mode)) ? (
        <Component {...props} />
      ) : (
        <NoAccess
          title={getI18n('general.websitemodeDesc')}
          subTitle={getI18n('general.websitemodePath')}
        />
      )
    ) : (
      <Component {...props} />
    );
  };
  return WrappedComponent;
};

export {
  SalesChannelModeAccessControlHOC,
  handleOnDisplay,
  handleOnDisplayComponent,
};
